import SmallMultiple from "./SmallMultiple/SmallMultipleMain";

const PvSmallMultipleLocation = ({ title, location_key, colors }) => {
  const items = [
    {
      title: "Balkon",
      explanationText:
      "Balkon-Photovoltaikanlagen sind kleine, steckerfertige Solarmodule für den Eigengebrauch, die typischerweise an Balkonen befestigt werden.",
      assetLocation: "Balcony",
    },
    {
      title: "Freifläche",
      explanationText:
        "Freiflächen-Photovoltaik bezeichnet Solaranlagen, die auf unbebauten Flächen wie Feldern oder ehemaligen Industriearealen installiert werden.",
      assetLocation: "Openspace",
    },
    {
      title: "Gebäude",
      explanationText:
      "Gebäude-Photovoltaik umfasst Solaranlagen, die an Gebäuden montiert sind, z.B. auf Dächern oder an Fassaden.",
      assetLocation: "Building",
    },
    {
      title: "Gewässer",
      explanationText:
        "Gewässer-Photovoltaikanlagen sind auf Gewässern schwimmende Solaranlagen, bei denen die Solarmodule auf Schwimmkörpern angebracht sind.",
      assetLocation: "Waters",
    },
    {
      title: "Großparkplatz",
      explanationText:
        "Großparkplatz-Photovoltaikanlagen sind Solaranlagen, die zur Überdachung von Großparkplätzen genutzt werden. Die Solarmodule ersetzen dabei das eigentliche Dach und erzeugen gleichzeitig Strom.",
      assetLocation: "Parking",
    },
  ];

  return (
    <>
      <h3 className="text-xl mt-10 mb-2 font-semibold text-center">{title}</h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 rounded-lg">
        {items.map(({ assetLocation, title, explanationText }, index) => (
          <div key={index} className="text-center flex flex-col items-center">
            <SmallMultiple
              textData={{
                summary: title,
                popoverText: explanationText,
              }}
              donutSpec={title}
              location_key={location_key}
              energySource={"pv"} // relevant for api-call
              unit={"MWp"}
              smallMultipleType = "location" // relevant for api-call
              LineChartTitle={'Installierte Leistung in MWp'}
              category={assetLocation}
              colors={colors}
            />
          </div>
        ))}
      </div>
    </>
  );
};

export default PvSmallMultipleLocation;
